module.exports = __webpack_public_path__ + "static/media/stop.dc7369be.png";